import { render, staticRenderFns } from "./headOfficeList.vue?vue&type=template&id=bb4c6b0c&scoped=true"
import script from "./headOfficeList.vue?vue&type=script&lang=js"
export * from "./headOfficeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4c6b0c",
  null
  
)

export default component.exports